<template>
  <section class="stock-access">
    <div class="stock-access__panel">
      <p>正在进入股票分析页面...</p>
      <a href="https://fanjunjie.cn/gupiao/">如果没有自动跳转，请点这里继续</a>
    </div>
  </section>
</template>

<script setup>
import { onMounted } from "vue";

onMounted(() => {
  if (typeof window !== "undefined") {
    window.location.replace("https://fanjunjie.cn/gupiao/");
  }
});
</script>

<style scoped>
.stock-access {
  min-height: 40vh;
  display: grid;
  place-items: center;
}

.stock-access__panel {
  display: grid;
  gap: 10px;
  padding: 24px 28px;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.88);
  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.12);
  text-align: center;
}

.stock-access__panel p {
  margin: 0;
  color: #10213a;
  font-size: 16px;
}

.stock-access__panel a {
  color: #2b6de5;
  text-decoration: none;
  font-weight: 600;
}
</style>
